import { Box, Grid, Theme, Typography } from "@mui/material";
import { KeyValue } from "../../ApplicationDetails/personalDetails";
import React, { useEffect, useState } from "react";
import { changeGoalVal, findRiskTolerance } from "../../../utils/utilityFunctions";
import { profiletext, updatedRiskProfile } from "../../investors/riskProfileDetails";
import { Applicant, RiskProfileMaster, profileType } from "../../../redux-store/types/api-types";
import { useDispatch } from "react-redux";
import { riskProfileMasterData } from "../../../redux-store/actions";
import { Item, ItemDetails } from "../../ApplicationDetails";
import { riskProfileDeclaration, riskProfileDonotWish } from "../../../utils/declaration";
import dayjs from "dayjs";

export default function RiskProfileDetails({ overviewData }: { overviewData: any }): JSX.Element {
    const { applicants } = overviewData || {};
    const applicant = applicants?.find((applicant: Applicant) => applicant.applicant_type === '1');
    const { riskprofiles = [], wishToAddRiskProfile, riskProfileGroup, riskProfileDeclarationDate = "", riskProfileExpiryDate = "" } = applicant || {};
    const [riskProfileData, setRiskProfileData] = useState<updatedRiskProfile[]>([]);
    const [profileData, setProfileData] = useState<profileType[]>([]);
    const dispatch = useDispatch();

    useEffect(() => {
        (async function () {
            try {
                if (Object.keys(overviewData ?? {}).length > 0) {
                    const response = (await dispatch(riskProfileMasterData({
                        riskProfileGroup: applicant?.riskProfileGroup ?? null,
                        company: overviewData?.company ?? null
                    }))) as unknown as RiskProfileMaster;

                    setRiskProfileData(
                        response?.riskProfile
                            ?.map((mdmsProfile) => {
                                const existingRiskProfiles = riskprofiles?.filter(
                                    (risk_profiles: any) => risk_profiles.question === mdmsProfile.key
                                );
                                setProfileData(response.profile);

                                return existingRiskProfiles?.map((existingProfiles: any) => {
                                    const checkAnswer = mdmsProfile.values
                                        ?.map((value) => {
                                            if (value.key === existingProfiles.answer) {
                                                return value.label;
                                            }
                                            return;
                                        })
                                        ?.filter((ele) => ele);
                                    return {
                                        ...existingProfiles,
                                        ...mdmsProfile,
                                        answer: checkAnswer?.toString() || existingProfiles.answer,
                                    };
                                });
                            })
                            ?.flat() as unknown as updatedRiskProfile[]
                    );
                }
            } catch (e) {
                console.log('Error', e);
            }
        })();
    }, [overviewData]);
    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    bgcolor: 'white',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                    padding: '25px',
                    mb: '40px'
                })}

            >
                <Box>
                    <Grid container >
                        <Typography variant='body_600' sx={(theme: Theme) => ({ fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
                            Risk Profile
                        </Typography>
                        <React.Fragment>
                            <Box sx={{ width: '100%' }}>

                                <Grid
                                    item
                                    container
                                    rowSpacing={3}
                                    columnSpacing={5.5}

                                >
                                    {riskProfileData?.length ? (
                                        <>
                                            <Grid
                                                item
                                                container
                                                spacing={2}
                                                sx={{
                                                    marginBottom: 2,
                                                    alignItems: "center",
                                                }}
                                            >
                                                {/* <Grid
                                                    item
                                                    container
                                                    xs={12}
                                                    lg={4}
                                                    sx={{
                                                        flexDirection: "column",
                                                        alignItems: "flex-start",
                                                        rowGap: "2px"
                                                    }}
                                                >
                                                    <Grid item>
                                                        <Typography
                                                            variant='body_500'
                                                            sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}
                                                        >
                                                            Question Set
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography
                                                            variant='body_500'
                                                            sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
                                                        >
                                                            {riskProfileGroup ?? "-"}
                                                        </Typography>
                                                    </Grid>
                                                </Grid> */}
                                                <Grid
                                                    item
                                                    container
                                                    xs={12}
                                                    lg={4}
                                                    sx={{
                                                        flexDirection: "column",
                                                        alignItems: "flex-start",
                                                        rowGap: "2px"
                                                    }}
                                                >
                                                    <Grid item>
                                                        <Typography
                                                            variant='body_500'
                                                            sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}
                                                        >
                                                            Declaration Date
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography
                                                            variant='body_500'
                                                            sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
                                                        >
                                                            {riskProfileDeclarationDate ? dayjs(riskProfileDeclarationDate).format('DD/MM/YYYY') : "-"}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid
                                                    item
                                                    container
                                                    xs={12}
                                                    lg={4}
                                                    sx={{
                                                        flexDirection: "column",
                                                        alignItems: "flex-start",
                                                        rowGap: "2px"
                                                    }}
                                                >
                                                    <Grid item>
                                                        <Typography
                                                            variant='body_500'
                                                            sx={(theme: Theme) => ({ color: theme.palette.text.secondary })}
                                                        >
                                                            Next Risk Profile Due Date
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography
                                                            variant='body_500'
                                                            sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
                                                        >
                                                            {riskProfileExpiryDate ? dayjs(riskProfileExpiryDate).format('DD/MM/YYYY') : "-"}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            {riskProfileData?.map((profileData) => {
                                                const profileAns = changeGoalVal(
                                                    profileData?.answer,
                                                    riskProfileData,
                                                    profileData?.question
                                                );
                                                return (
                                                    <React.Fragment key={profileData?.id}>
                                                        {profileData.isMultiselect === 'false' ? (
                                                            <KeyValue
                                                                // title={profileData.displayText}
                                                                // description={profileData.answer}
                                                                title={profileData.questionText}
                                                                description={profileData.answerText}
                                                            />
                                                        ) : (
                                                            <Grid item xs={12} sm={6}>
                                                                <Item>{profileData.displayText}</Item>
                                                                {profileData.key === 'realizingMarketBasedInvestments' ? (
                                                                    profileAns && profileAns?.length > 0 ? (
                                                                        profileAns?.map((ans, ind) => (
                                                                            <Box
                                                                                key={ind}
                                                                                sx={{ display: 'flex', alignItems: 'baseline' }}>
                                                                                <Typography
                                                                                    sx={{ fontSize: '30px', fontWeight: 900, pr: 1 }}>
                                                                                    .
                                                                                </Typography>
                                                                                <ItemDetails> {ans}</ItemDetails>
                                                                            </Box>
                                                                        ))
                                                                    ) : (
                                                                        <ItemDetails>-</ItemDetails>
                                                                    )
                                                                ) : (
                                                                    <ItemDetails> {profileAns?.toString() || '-'}</ItemDetails>
                                                                )}
                                                            </Grid>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}

                                            <Box sx={{ display: 'flex', columnGap: "40px", marginLeft: '45px', mt: '35px', mb: '35px' }}>
                                                <Box>
                                                    {applicant?.totalRiskProfileScore && (
                                                        <>
                                                            <Grid item xs={12} display="flex" alignItems={'flex-start'}>

                                                                <Typography
                                                                    variant='body_500'
                                                                    sx={(theme: Theme) => ({
                                                                        color: theme.palette.common.white,
                                                                        backgroundColor: theme.palette.success[500],
                                                                        padding: '10px 20px',
                                                                        borderRadius: '5px'

                                                                    })}>{`Your total Score: ${applicant?.totalRiskProfileScore}`}</Typography>
                                                            </Grid>
                                                        </>
                                                    )}
                                                </Box>
                                                <Box>
                                                    {applicant?.riskProfile && (
                                                        <>
                                                            <Grid item xs={12} display="flex" alignItems={'flex-start'}>

                                                                <Typography
                                                                    variant='body_500'
                                                                    sx={(theme: Theme) => ({
                                                                        color: theme.palette.common.white,
                                                                        backgroundColor: theme.palette.warning[500],
                                                                        padding: '10px 20px',
                                                                        borderRadius: '5px'

                                                                    })}>{`Risk Profile: ${applicant?.riskProfile}`}</Typography>
                                                            </Grid>

                                                        </>
                                                    )}
                                                </Box>
                                            </Box>
                                            {overviewData?.riskProfileDeclaration && (
                                                <Grid item xs={12} display="flex" alignItems={'flex-start'}>
                                                    {/* <Checkbox defaultChecked disabled={true} /> */}
                                                    <Typography
                                                        variant='body_500'
                                                        sx={{

                                                            color: 'text.primary',
                                                            letterSpacing: '0.02px',
                                                        }}>
                                                        {riskProfileDeclaration}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </>
                                    ) : wishToAddRiskProfile ? (
                                        <Grid item xs={12} display="flex" alignItems={'flex-start'}>
                                            {/* <Checkbox defaultChecked disabled={true} /> */}
                                            <Typography
                                                sx={{
                                                    fontSize: 15,
                                                    fontWeight: 700,
                                                    color: 'rgba(0, 0, 0, 0.6)',
                                                    letterSpacing: '0.5px',
                                                }}>
                                                {riskProfileDonotWish}
                                            </Typography>
                                        </Grid>
                                    ) : (
                                        <Grid
                                            xs={12}
                                            sm={12}
                                            sx={{
                                                fontSize: 18,
                                                fontWeight: 600,
                                                color: 'common.black',
                                                textAlign: 'center',
                                                my: 3,
                                            }}>
                                            No Risk Profile
                                        </Grid>
                                    )}
                                </Grid>

                            </Box>
                        </React.Fragment>
                    </Grid>
                </Box>
            </Box>
        </>
    );

    //     <>
    //         <Box
    //             sx={(theme: Theme) => ({
    //                 bgcolor: 'white',
    //                 boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    //                 borderRadius: '10px',
    //                 border: `1px solid ${theme.palette.grey[100]}`,
    //                 padding: '25px',
    //                 mb: '40px'
    //             })}
    //         >
    //             <Box>
    //                 <Grid container >
    //                     <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
    //                         Risk Profile
    //                     </Typography>
    //                     {banks?.length === 0 ? (
    //                         <Grid
    //                             xs={12}
    //                             sm={12}
    //                             sx={{
    //                                 fontSize: 16,
    //                                 fontWeight: 600,
    //                                 color: 'text.primary',
    //                                 textAlign: 'center',
    //                                 my: 1.5,
    //                             }}>
    //                             No Bank Details
    //                         </Grid>
    //                     ) : (
    //                         banks?.map((bank, index: number) => {
    //                             const title = ['Bank 1 Details', 'Bank 2 Details', 'Bank 3 Details'][index];
    //                             const bankAddress = getBankAddress(bank.address1, bank.address2, bank.address3);
    //                             return (
    //                                 <React.Fragment key={bank.id}>
    //                                     <SubHeading sx={{ letterSpacing: "0.02px" }}>{title}</SubHeading>

    //                                     <Grid
    //                                         item
    //                                         container

    //                                         rowSpacing={3}
    //                                         columnSpacing={5.5}
    //                                         direction="row"

    //                                     >
    //                                         <KeyValue title={'IFSC Code'} description={bank.ifscCode} />
    //                                         <KeyValue
    //                                             title={'Bank Account Number'}
    //                                             description={bank.bankAccountNumber}
    //                                         />
    //                                         <KeyValue title={'MICR Code'} description={bank.micrCode} />
    //                                         <KeyValue title={'Bank Type'} description={bank.bankAccountType} />
    //                                         <KeyValue title={'Bank Name'} description={bank.bankName} />
    //                                         <KeyValue title={'Branch Name'} description={bank.bankBranch} />
    //                                         <KeyValue
    //                                             title={`Bank Address`}
    //                                             description={`${bankAddress}`}
    //                                             sx={{
    //                                                 textTransform: 'capitalize',
    //                                             }}
    //                                         />
    //                                         <KeyValue
    //                                             title={`Default Bank Account`}
    //                                             description={bank.defaultBankAccount ? 'Yes' : '-'}
    //                                         />
    //                                     </Grid>

    //                                 </React.Fragment>
    //                             );
    //                         })
    //                     )}
    //                 </Grid>
    //             </Box>
    //         </Box >
    //     </>
    // );
}
